var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cam-host" }, [
    _c("div", { staticClass: "m-wrap" }, [
      _c("div", { staticClass: "m-hero" }, [
        _c("img", { staticClass: "m-bg", attrs: { src: _vm.bgSrc, alt: "" } }),
        _c("div", { staticClass: "m-title" }, [
          _c("div", { staticClass: "m-title__line1" }, [
            _vm._v(_vm._s(_vm.$t("Cambodia"))),
          ]),
          _c("div", { staticClass: "m-title__line2" }, [
            _vm._v(_vm._s(_vm.$t("Cockfight Rules"))),
          ]),
        ]),
        _c("div", { staticClass: "m-row m-row--auto" }, [
          _c("div", { staticClass: "m-row__text" }, [
            _c("div", { staticClass: "m-row__small" }, [
              _vm._v(_vm._s(_vm.$t("Touching or Catching ="))),
            ]),
            _c("div", { staticClass: "m-row__big" }, [
              _vm._v(_vm._s(_vm.$t("Automatic Loss"))),
            ]),
          ]),
          _c("img", {
            staticClass: "m-row__icon",
            attrs: { src: _vm.noCatchSrc, alt: "" },
          }),
        ]),
        _c("div", { staticClass: "m-strip m-strip--red" }, [
          _c("img", {
            staticClass: "m-strip__icon m-strip__icon--left",
            attrs: { src: _vm.noExternalHelpSrc, alt: "" },
          }),
          _c("div", { staticClass: "m-strip__content" }, [
            _c("div", { staticClass: "m-strip__title" }, [
              _vm._v(_vm._s(_vm.$t("No External Help"))),
            ]),
            _c("div", { staticClass: "m-strip__desc" }, [
              _c("div", [
                _vm._v(_vm._s(_vm.$t("No fixing, No beak adjustment"))),
              ]),
              _c("div", [_vm._v(_vm._s(_vm.$t("No water")))]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "m-strip m-strip--blue" }, [
          _c(
            "div",
            { staticClass: "m-strip__content m-strip__content--left" },
            [
              _c(
                "div",
                { staticClass: "m-strip__title m-strip__title--left" },
                [_vm._v(_vm._s(_vm.$t("Defeated if")))]
              ),
              _c("ul", { staticClass: "m-list" }, [
                _c("li", { staticClass: "m-list__item" }, [
                  _c("img", {
                    staticClass: "m-bullet",
                    attrs: { src: _vm.checkBulletSrc, alt: "" },
                  }),
                  _c("span", [_vm._v(_vm._s(_vm.$t("Lies Flat")))]),
                ]),
                _c("li", { staticClass: "m-list__item" }, [
                  _c("img", {
                    staticClass: "m-bullet",
                    attrs: { src: _vm.checkBulletSrc, alt: "" },
                  }),
                  _c("span", [_vm._v(_vm._s(_vm.$t("Runs Away / Cries")))]),
                ]),
                _c("li", { staticClass: "m-list__item" }, [
                  _c("img", {
                    staticClass: "m-bullet",
                    attrs: { src: _vm.checkBulletSrc, alt: "" },
                  }),
                  _c("span", [_vm._v(_vm._s(_vm.$t("No Retaliation × 3")))]),
                ]),
              ]),
              _c("div", { staticClass: "m-note" }, [
                _vm._v(" " + _vm._s(_vm.$t("Standing beats Kneeling;"))),
                _c("br"),
                _vm._v(" " + _vm._s(_vm.$t("Kneeling beats Lying Flat")) + " "),
              ]),
            ]
          ),
          _c("img", {
            staticClass: "m-strip__icon m-strip__icon--right",
            attrs: { src: _vm.defeatedSrc, alt: "" },
          }),
        ]),
        _c("div", { staticClass: "m-strip m-strip--bottom" }, [
          _c("img", {
            staticClass: "m-warn",
            attrs: { src: _vm.warnSrc, alt: "" },
          }),
          _c("div", { staticClass: "m-bottom-text" }, [
            _vm._v(_vm._s(_vm.$t("NO ABUSED or POISONING ALLOWED"))),
          ]),
        ]),
        _c("div", { staticClass: "m-footnote" }, [
          _vm._v(_vm._s(_vm.$t("*Arena Judge decision is final."))),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }